import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { RomaneioService } from 'src/app/estoque/romaneio/service/romaneio.service';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { ControleQualidadeCadastroItem, ControleQualidadeCadastroLista, ControleQualidadeItem, getControleQualidadeCadastroListaDefault } from '../../interface/controle-qualidade';
import { Zpr } from 'src/app/interface/zpr';
import { FiltroControleQualidadeLista } from '../../filter/filtro-controle-qualidade-lista';
import { PoStorageService } from '@po-ui/ng-storage';

@Component({
  selector: 'app-controle-qualidade-cadastro',
  templateUrl: './controle-qualidade-cadastro.component.html',
  styleUrls: ['./controle-qualidade-cadastro.component.css']
})
export class ControleQualidadeCadastroComponent implements OnInit {

  etiqueta: string = '';
  etqAuto: boolean = false;
  impressora: string = '';
  nCopias: string = '1';
  codImpr: string = '';
  impAuto: string = '';
  copiasAuto: string = '1';
  controleQualidade: ControleQualidadeCadastroLista;
  bipadasHoje: Array<any>;

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  filtroLista: FiltroControleQualidadeLista;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private romaneioService: RomaneioService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    private poStorageService: PoStorageService,
    public zprService: ZprLookupService,
  ) {
    this.controleQualidade = getControleQualidadeCadastroListaDefault();

    this.zprService.grupo        = 'MOTQUALID';
    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;

    this.filtroLista = new FiltroControleQualidadeLista(this.poStorageService);

    this.bipadasHoje = [];
  }

  @ViewChild('reprovarModal', { static: true }) reprovarModal!: PoModalComponent;
  @ViewChild('impressaoModal', { static: true }) impressaoModal!: PoModalComponent;

  ngOnInit(): void {
    this.filtroLista.dados = this.filtroLista.setDefault();
    this.filtroLista.dados.CAPENASUSUARIO = 'S';
    this.romaneioService.getControleQualidadeLista(this.filtroLista.dados).subscribe((ret) => {
      this.bipadasHoje = ret.items.map((item) => {
        return {...item, favorite: item.CZ04STATUS == 'A' ? ['imprimir'] : []};
      });
    })
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Controle Qualidade', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Novo Cadastro' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToLista(): void {
    this.router.navigateByUrl('/estoque/romaneio/controle-qualidade/lista');
  }

  public readonly colunas: Array<PoTableColumn> = [
    { property: 'CZ04LOTE', visible: true, label: 'Etiqueta' },
    { property: 'CB1COD', visible: false, label: 'Produto' },
    { property: 'CB1DESC', visible: true, label: 'Descrição' },
    { property: 'NQTD', visible: true, label: 'Quantidade' },
    {
      property: 'favorite',
      label: '...',
      type: 'icon',
      width: '10%',
      icons: [
        {
          action: this.excluirItem.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir Item',
          value: 'delete',
        },
      ]
    },
  ];

  public readonly colunasBipadas: Array<PoTableColumn> = [
    {property: 'CZ04CODIGO' , label: 'Código'           , width: '10%'},
    {property: 'CZ04LOTE'   , label: 'Lote'             , width: '10%'},
    {property: 'DZ04DATA'   , label: 'Data'             , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ04HORA'   , label: 'Hora'            , width: '10%'},
    {property: 'CZ04TURNO'  , label: 'Turno'            , width: '10%'},
    {property: 'CZ04STATUS' , label: 'Status'           , width: '10%', type: 'label',
      labels: [
        { value: 'A', color: 'color-01',  label: 'Aprovado'    },
        { value: 'R', color: 'color-05',  label: 'Recusado' },
      ]
    },
    {property: 'CZPRGENERI' , label: 'Motivo'         , width: '30%'},
    {property: 'favorite', label: '...', width: '10%', type: 'icon',
      icons: [
        {
          action: this.imprimirAction.bind(this),
          icon: 'po-icon-print',
          tooltip: 'Imprimir etiqueta',
          value: 'imprimir',
        },
      ]
    },
  ];

  excluirItem(row: ControleQualidadeCadastroItem): void {
    this.controleQualidade.items = this.controleQualidade.items.filter((item) => {
      return item.CZ04LOTE != row.CZ04LOTE;
    });
  }

  biparEtiqueta(): void {
    if (this.etiqueta != '') {
      let etiq = this.etiqueta;
      if (etiq.length > 7 && etiq.substring(0,3) == "000") {
        etiq = etiq.substring(3,etiq.length);
      }

      let lContinua = true;
      this.controleQualidade.items.map((itemControle) => {
        if (itemControle.CZ04LOTE == etiq) {
          lContinua = false;
        }
      });

      if (lContinua) {
        this.romaneioService.getDadosEtiquetaControleQualidade(etiq).subscribe((ret) => {
          const reaprovacaoLiberada = ret.CZ04STATUS == "A" && ret.CZ03ENVLOT == "S";

          if (ret.CZ04STATUS != "A" || reaprovacaoLiberada) {
            this.controleQualidade.items.push({...ret, CZ04LOTE: etiq, favorite: ['delete']});
            if (ret.CZ04STATUS == "R") {
              this.poNotificationService.warning("Aviso: Esta etiqueta já foi rejeitada uma vez e agora só poderá ser aprovada!")
            } else if (reaprovacaoLiberada) {
              this.poNotificationService.warning("Aviso: esta etiqueta já foi aprovada, mas o lote foi liberado (Enviado Lote) para nova aprovação.")
            }
          } else {
            this.poNotificationService.error("Esta etiqueta já foi aprovada anteriormente!")
          }
        });
      } else {
        this.poNotificationService.error("Esta etiqueta já consta neste Controle de Qualidade!")
      }
      this.etiqueta = '';
    }
  }

  modalReprovarOpen(): void {
    this.zprService.grupo = 'MOTQUALID';
    this.reprovarModal.open();
  }

  aprovarEtiquetas(): void {
    if (this.controleQualidade.items.length == 0) {
      this.poNotificationService.error("Informe ao menos uma etiqueta para aprovação!");
      return;
    }

    if (this.etqAuto && this.impAuto == '') {
      this.poNotificationService.error("Selecione a impressora da etiqueta automática!");
      return;
    }

    this.controleQualidade.motivo='';
    this.controleQualidade.status='A';
    this.romaneioService.postControleQualidade(this.controleQualidade).subscribe(() => {
      if (this.etqAuto) {
        this.controleQualidade.items.map((item) => {
          this.imprimirEtiquetaLote(item.CZ04LOTE);
        });
        this.poNotificationService.success("Etiqueta(s) aprovada(s) e enviada(s) para impressão!");
        this.goToLista();
      } else {
        this.poNotificationService.success("Etiqueta(s) aprovada(s) com sucesso!");
        this.goToLista();
      }
    });
  }

  imprimirEtiquetaLote(lote: string): void {
    this.romaneioService.getEtiquetaControleQualidade('L', lote, this.impAuto, this.copiasAuto).subscribe((res) => {
      if (this.impAuto == 'PDF') {
        this.baixarEtiqueta(res, lote);
      }
    });
  }

  trocaEtiquetaAutomatica(): void {
    if (this.etqAuto) {
      this.codImpr = '';
      this.impressora = this.impAuto;
      this.nCopias = this.copiasAuto;
      this.zprService.grupo = 'PRINTLIST';
      this.impressaoModal.open();
    } else {
      this.impAuto = '';
      this.copiasAuto = '1';
    }
  }

  imprimirAction(row: ControleQualidadeItem): void {
    this.codImpr = row.CZ04CODIGO;
    this.impressora = 'PDF';
    this.nCopias = '1';
    this.zprService.grupo = 'PRINTLIST';
    this.impressaoModal.open();
  }

  public readonly imprimirActionModal: PoModalAction = {
    action: () => {
      if (this.impressora == '') {
        this.poNotificationService.error("Selecione uma impressora!");
        return;
      }

      if (this.codImpr != '') {
        this.impressaoModal.close();
        this.imprimirEtiqueta(this.codImpr);
      } else {
        this.impAuto = this.impressora;
        this.copiasAuto = this.nCopias;
        this.impressaoModal.close();
        this.poNotificationService.success("Impressora configurada para a etiqueta automática!");
      }
    },
    label: 'Selecionar'
  };

  fecharImpressao(): void {
    if (this.etqAuto && this.codImpr == '' && this.impAuto == '') {
      this.etqAuto = false;
    }
    this.zprService.grupo = 'MOTQUALID';
  }

  imprimirEtiqueta(codigo: string): void {
    this.romaneioService.getEtiquetaControleQualidade('C', codigo, this.impressora, this.nCopias).subscribe((res) => {
      if (this.impressora == 'PDF') {
        this.baixarEtiqueta(res, codigo);
      } else {
        this.poNotificationService.success("Etiqueta enviada para impressão!");
      }
    });
  }

  baixarEtiqueta(res: Blob, chave: string): void {
    const file = new Blob([res], {type: 'application/pdf'});
    const fileName = `ETIQUETA_QUALIDADE_${chave}.pdf`;
    const link = document.createElement('a');
    const fileURL = window.URL.createObjectURL(file);

    document.body.appendChild(link);
    link.href = fileURL;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(fileURL);
    link.remove();
  }

  public readonly reprovarAction: PoModalAction = {
    action: () => {
      if (this.controleQualidade.motivo != '') {
        this.reprovarModal.close();
        this.controleQualidade.status='R';
        this.romaneioService.postControleQualidade(this.controleQualidade).subscribe((ret) => {
          this.poNotificationService.success("Etiqueta(s) reprovada(s) com sucesso!");
          this.goToLista();
        });
      } else {
        this.poNotificationService.error("Por favor, preencha o motivo da rejeição!");
      }
    },
    label: 'Reprovar'
  };

}
